import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-diamond-purchase-modal',
  templateUrl: './diamond-purchase-modal.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class DiamondPurchaseModalComponent {
  @Input() phone: string = '';
  @Input() diamondAmount: number = 0;

  constructor(public activeModal: NgbActiveModal) {}

  isValid(): boolean {
    return this.phone.trim().length > 0 && this.diamondAmount > 0;
  }

  submit(): void {
    if (!this.isValid()) return;

    // Chỉ trả về dữ liệu cần thiết
    this.activeModal.close({
      phone: this.phone,
      diamondAmount: this.diamondAmount
    });
  }
}
